import { render, staticRenderFns } from "./GameCloseTimer.vue?vue&type=template&id=2a0830aa&"
import script from "./GameCloseTimer.vue?vue&type=script&lang=js&"
export * from "./GameCloseTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports